export function getSocialMedia(data) {
  const sm = data.acf.reader_profile_description_socials;
  return sm && Object.values(sm).filter((value) => value !== '');
}
